import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./item.module.css";
const ListItemInner = (props, ref) => {
    const { asChild = false, disabled, className, onClick, isClickable, ...otherProps } = props;
    const Component = asChild ? Slot : "li";
    const addClickableClassName = onClick || isClickable;
    return (_jsx(Component, { role: "listitem", ...otherProps, ref: asChild ? undefined : ref, className: clsx(styles.item, className, {
            [styles.disabled]: disabled,
            [styles.clickable]: addClickableClassName,
        }), "aria-disabled": disabled, onClick: onClick, tabIndex: isClickable ? 0 : undefined }));
};
ListItemInner.displayName = "List.Item";
const ListItem = forwardRef(ListItemInner);
export { ListItem };
